import { render, staticRenderFns } from "./KYCList.vue?vue&type=template&id=f36bca04&scoped=true"
import script from "./KYCList.vue?vue&type=script&lang=js"
export * from "./KYCList.vue?vue&type=script&lang=js"
import style0 from "./KYCList.vue?vue&type=style&index=0&id=f36bca04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36bca04",
  null
  
)

export default component.exports